import httpService from "./httpService";

export let postNote = (data: any) => {
  return httpService.post("form-landing", data);
};

